export const getCustomerComplaint = state => state.customerComplaint;
